export default "__VITE_ASSET__DgvrATcj__"